import { render } from "./MobileRegisterPopup.vue?vue&type=template&id=c8900608&scoped=true"
import script from "./MobileRegisterPopup.vue?vue&type=script&lang=js"
export * from "./MobileRegisterPopup.vue?vue&type=script&lang=js"

import "./MobileRegisterPopup.vue?vue&type=style&index=0&id=c8900608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8900608"]])

export default __exports__